import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';
import { AppRoutes, useNavBack } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { PerfumerService } from '~/service/service.perfumer';
import { UIService } from '~/service/service.ui';
import { PerfumerCreateDto } from '~/shared/dto/admin/perfumer.dto';
import { Form } from '~/shared/form/form';
import { useService } from '~/shared/service/service.base';
import { FieldImages } from '~/view/fields/field.images';
import { FieldNumber } from '~/view/fields/field.number';
import { FieldSwitch } from '~/view/fields/field.switch';
import { FieldText } from '~/view/fields/field.text';
import { EditCenter, EditContainer, EditLeft, EditRight } from '~/view/view.edit';

export const PerfumerEditPage = observer(() => {
	const [ui, auth, perfumers] = useService(UIService, AuthService, PerfumerService);
	const navBack = useNavBack();
	const { id } = useTypedParams(AppRoutes.PerfumerEdit);

	const form = Form.use(PerfumerCreateDto, {
		name: 'PerfumerCreateDto',
		onSubmit: dto =>
			perfumers.save(id, dto).then(() => {
				navBack();
				ui.notify('Perfumer saved successfully', 'success');
			}),
		initial: () => perfumers.getOne(id),
	});

	ui.usePageTitle(form.initial?.name ? `Perfumer - ${form.initial?.name}` : '');
	const canSave = id ? auth.can('perfumers', 'UPDATE') : auth.can('perfumers', 'CREATE');

	return (
		<EditContainer async={perfumers.async}>
			<EditLeft>
				<FieldImages field={form.$images} images={form.initial?.images} />
			</EditLeft>
			<EditCenter>
				<FieldNumber disabled={!!id} field={form.$id} />
				<FieldText field={form.$name} />
				<FieldText field={form.$description} multiline />
				<FieldText field={form.$company} />
				<FieldText multiline field={form.$comment} />
				<FieldSwitch field={form.$active} />
			</EditCenter>
			<EditRight>
				<Button variant="contained" onClick={form.submit} disabled={!canSave}>
					Save
				</Button>
				<br />
				<Button variant="outlined" onClick={navBack}>
					Cancel
				</Button>
				<Button variant="outlined" onClick={form.reset}>
					Reset
				</Button>
				{id && (
					<>
						<br />
						<Button
							disabled={!auth.can('perfumers', 'DELETE')}
							variant="outlined"
							color="error"
							onClick={() =>
								ui.confirmDelete(() =>
									perfumers.delete(id).then(() => {
										navBack();
										ui.notify('Perfumer deleted successfully', 'success');
									}),
								)
							}
						>
							Delete
						</Button>
					</>
				)}
			</EditRight>
		</EditContainer>
	);
});
